<template>
  <em
    class="mdi text-light-warning dark:text-dark-warning"
    :class="NO_ENTRY_ICON"
  />
</template>
<script setup lang="ts">
import { NO_ENTRY_ICON } from '@/enums/icons';
</script>
